import { IGetAllInspecaoObraItemUseCase } from "../../../presentation/useCases/read/get_all_inspecao_obra_item_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { InspecaoObraItem } from "../../models/inspecao_obra_item";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetAllInspecaoObraItemUseCase
 */

export class GetAllInspecaoObraItemUseCase
  extends BasePaginatedUseCase<InspecaoObraItem>
  implements IGetAllInspecaoObraItemUseCase {
  constructor(private readonly repository: IObrasRepository) {
    super();
  }

  async getAllInspecaoObraItem(
    idInspecaoObra: number | undefined,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (idInspecaoObra === undefined) throw new Error('Id de inspeção obra invalido!');

    const response = await this.repository.getAllInspecaoObraItem(
      idInspecaoObra,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
